import keymirror from 'keymirror';

const takerMessageComponentTypes = keymirror({
  nextivaSurveyAlreadyTaken: null,
});

export default takerMessageComponentTypes;
